export const SMSToBookNumber = '1-877-874-5078';
export const CallToBookNumber = '1-866-468-2488';
export const MonToFriHours = '7AM-11PM MST Mon-Fri';
export const SatToSunHours = '9AM-9PM MST Sat-Sun';
export const EmailToBook = 'reservations@frontierlodging.com';
export const HotelUnavailableOnlineMessage =
  'This hotel is not available to book online, but may still have rooms. Please contact Frontier Lodging Solutions for booking options.';
export const DisabledByBookingRestrictionMessage = (days: number | undefined) =>
  `Hotel not available to book online.  Payment card not accepted within ${days} days of check in. Please select a different hotel or contact Frontier for more information.`;
export const DisabledByCompanyCountryPolicyMessage =
  'This hotel is disabled by company policy. Please contact Frontier Lodging Solutions for booking options.';
export const LowestRateNotDisplayedMessage =
  'Lowest Rate for this hotel is not displayed due to policies that include NO CANCELLATION and NON REFUNDABLE';
export const tAndCsGenericText = `
  Hotel cancellation policy varies by hotel. Same day cancelations may result in fees or penalties. 
  Please refer to your itinerary for cancellation dates and times. If itinerary does not show cancellation policy, 
  contact Frontier Lodging Solutions immediately for more information. Frontier Lodging Solutions will not be responsible 
  for any costs associated with cancelations that don't adhere to the hotel's policy. If cancellation request is within 
  1 hour of cancellation deadline, traveler must call Frontier Lodging Solutions reservation team to process cancellation.
  `;

export const siteModeBusiness = 'Business';
export const siteModeDemo = 'Demo';
export const siteModePersonal = 'Personal / LOA';
export const emailRegex =
  /^\s*[;,]*\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*([;,]\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*\s*[;,]?\s*$/;

export const multipleRoomModeCurrentBookingColId = 'currentBookingContainer';
export const multipleRoomModeCurrentBookingSelectedHotelAndRatesContainer =
  'currentBookingSelectedHotelAndRatesContainer';

export const ongoingProjectsWarningPhoneNumber = '825-540-7871';
export const ongoingProjectsWarningemail = 'groups@Frontierlodging.com';
